import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import FilterPanel from './components/filter-panel/filter-panel';

import { clearFilter } from '../../store/actions/filter';

import './C3-filter.scss';

class C3Filter extends Component {
	constructor(props) {
		super(props);

		this.wrapperClose = this.wrapperClose.bind(this);
		this.clearAll = this.clearAll.bind(this);
		this.toggleCollapsible = this.toggleCollapsible.bind(this);
		this.filterRef = React.createRef();

		this.state = {
			isOpen: false,
		};
	}

	wrapperClose(evt) {
		if (this.filterRef.current.contains(evt.target)) {
			return;
		}

		this.setState({
			isOpen: false,
		});
	}

	clearAll() {
		const { data, dispatch } = this.props;
		const sectionIds = data.availableFilters.sections.map((section) => { return section.id; });

		dispatch(clearFilter(sectionIds));
	}

	toggleCollapsible() {
		const { isOpen } = this.state;

		this.setState({
			isOpen: !isOpen,
		});
	}

	render() {
		const { isOpen } = this.state;
		const {
			data,
			viewport,
			content: {
				textClose,
				textClear,
				textOpen,
			},
		} = this.props;

		let buttonClass = 'C3-filter__button';
		let wrapperClass = 'C3-filter__wrapper';

		if (['lg', 'xl', 'xxl'].includes(viewport)) {
			buttonClass += ' is-desktop';
		}

		if (['xs', 'sm', 'md'].includes(viewport)) {
			wrapperClass += ' is-device';
		}

		if (isOpen || ['lg', 'xl', 'xxl'].includes(viewport)) {
			wrapperClass += ' is-open';
		}

		return (
			<React.Fragment>
				<div className={buttonClass}>
					<span className="C3-filter__button__title" role="presentation" onClick={this.toggleCollapsible}>{(isOpen && ['xs', 'sm'].includes(viewport)) ? textClose : textOpen}</span>
				</div>
				<div className={wrapperClass} role="presentation" onClick={this.wrapperClose}>
					<div className="C3-filter__filter" ref={this.filterRef}>
						<div className="C3-filter__header">
							<span className="C3-filter__header__title" role="presentation" onClick={this.toggleCollapsible}>{(isOpen && ['xs', 'sm'].includes(viewport)) ? textClose : textOpen}</span>
							<button type="button" className="C3-filter__header__action btn btn--primary btn--small" role="presentation" onClick={this.clearAll}>{textClear}</button>
						</div>
						<div className="C3-filter__collapsible">
							{data.availableFilters.sections.map((section) => {
								return (
									<FilterPanel
										key={section.id}
										section={section}
										defaultLanguage={data.defaultLanguage}
									/>
								);
							})}
						</div>
					</div>
					<div className="C3-filter__tablet-close" />
				</div>
			</React.Fragment>
		);
	}
}

C3Filter.defaultProps = {
	viewport: 'xl',
	data: {
		defaultLanguage: 'en-US',
		availableFilters: {
			sections: [],
		},
	},
	content: {
		textOpen: 'Filter by',
		textClose: 'Close Filter',
		textClear: 'Clear all',
	},
	dispatch: () => {},
};

C3Filter.propTypes = {
	viewport: PropTypes.string,
	data: PropTypes.shape({
		defaultLanguage: PropTypes.string,
		availableFilters: PropTypes.shape({
			sections: PropTypes.arrayOf(PropTypes.shape({
				id: PropTypes.string,
				title: PropTypes.string,
				type: PropTypes.string,
				categories: PropTypes.arrayOf(PropTypes.shape({
					id: PropTypes.string,
					title: PropTypes.string,
					results: PropTypes.string,
					topics: PropTypes.arrayOf(PropTypes.shape({
						id: PropTypes.string,
						title: PropTypes.string,
						results: PropTypes.string,
					})),
				})),
			})),
		}),
	}),
	content: PropTypes.shape({
		textOpen: PropTypes.string,
		textClose: PropTypes.string,
		textClear: PropTypes.string,
	}),
	dispatch: PropTypes.func,
};

const mapStateToProps = (state) => {
	return {
		viewport: state.global.viewport || null,
	};
};

export default connect(mapStateToProps)(C3Filter);
